export const hasPrice = (m) => !m.contact_for_price && Number(m.price) > 0;

export const isBuyNow = (m) => hasPrice(m);

export const STOCK_LABELS = {
    in_stock: 'In Stock',
    ships_7_14: 'Ships in 7–14 days',
    backorder: 'Backorder',
};

export const stockStatus = (m) => {
    const a = m.availability || 'auto';
    if (a !== 'auto') return a;
    if (m.inventory_count == null || m.inventory_count > 0) return 'in_stock';
    return 'ships_7_14';
};

export const stockLabel = (m) => {
    const s = stockStatus(m);
    if (s === 'in_stock' && m.inventory_count > 0 && m.inventory_count <= 5) return `In Stock — only ${m.inventory_count} left`;
    return STOCK_LABELS[s];
};

export const quoteLabel = () => 'Get Current Price';

export const US_STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];
